module.exports = __webpack_public_path__ + "media/images/icons/commissie-078d36c368199ce343a4425953a35080.svg";